import AuthService from "./AuthService";
import { baseUrl } from "../helpers/Url";

export function get(id = "") {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/${id}`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function getInfiniteUsers(userFilter) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/infiniteUsers`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userFilter),
  });
}

export function recoverAccount(email) {
  return fetch(`${baseUrl}/api/userManager/recovery?email=${email}`, {
    method: "POST",
  });
}

export function validateAccountRecovery(token, email) {
  return fetch(
    `${baseUrl}/api/userManager/recovery-validation?token=${token}&email=${email}`,
    {
      method: "POST",
    }
  );
}

export function resetPassword(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/${id}/resetPassword`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function add(requestUser) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestUser),
  });
}

export function update(id, requestUser) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestUser),
  });
}

export function remove(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function getPlantAccess(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/plantaccess/${id}`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function getZoneAccess(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/zoneaccess/${id}`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function addPlantAccess(id, plantId) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/plantaccess/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(plantId),
  });
}

export function addZoneAccess(id, zoneId) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/zonaaccess/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(zoneId),
  });
}

export function changePlantAccessType(paId, accessType) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/plantaccess/${paId}/type`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(accessType),
  });
}

export function removePlantAccess(id, plantId) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/plantaccess/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(plantId),
  });
}

export function removeZoneAccess(id, zoneList) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/zonaaccess/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(zoneList),
  });
}

export function deshabilitarUsuario(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/${id}/disable`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
}

export function habilitarUsuario(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/${id}/enable`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
}

export function getUserPartner() {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/getUserPartner`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function emailReminder() {
  return fetch(`${baseUrl}/api/userManager/remindertest`, {});
}

export function turnOffReminder(id) {
  return fetch(`${baseUrl}/api/userManager/reminderoff`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(id),
  });
}

export function getRoles(id) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/roles`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function changeRole(changeRoleRequest) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/changerole`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(changeRoleRequest),
  });
}

export function RequestAccesByOtherUser(request) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/requestaccess/anotherUser`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });
}

export function getUsersFromPlant(plantId) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/plant/${plantId}/userList`, {
    headers: { Authorization: `Bearer ${access_token}` },
  });
}

export function sendPlantInfoEmailToRequestedUsers(plantId, users) {
  const userInfo = AuthService.getUserInfo();
  const access_token = userInfo.access_token;

  return fetch(`${baseUrl}/api/userManager/plant/${plantId}/getPlantInfo`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${access_token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(users),
  });
}

export function getExtraData(token, userId) {
  return fetch(
    `${process.env.REACT_APP_DIP_USERS_URL}${userId}?include_legal_info=false&user_id_type=EMAIL`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
}
